<template>
  <div v-if="isModerno" class="banner-notin-modern-inner" :style="wrapperStyle">
    <v-container>
      <v-row :class="['align-center', 'row-gap-30', 'banner-row-modern-inner', { 'flex-row-reverse': obj?.ImageLeft }]">
        <!-- Column 1: Info (Glassmorphic) -->
        <v-col lg="7" md="7" sm="12" cols="12" class="d-flex">
          <div class="banner-glass-premium-inner w-100" :style="{ textAlign: estiloTituloAlign }">
            <h1 class="heading-modern-inner mb--25" :style="tituloStyle">
              {{ obj.Titulo.Texto }}
            </h1>
            <h2 v-if="obj.Subtitulo && obj.Subtitulo.Texto !== ''" class="subheading-modern-inner mb--30" :style="subtituloStyle">
              {{ obj.Subtitulo.Texto }}
            </h2>
            <div v-if="obj.ShowButton" class="slide-btn-modern-inner mt--10">
              <a class="rn-btn btn-modern-primary-inner" :href="obj.Button.Click" :style="buttonStyle">
                {{ obj.Button.Texto }}
              </a>
            </div>
          </div>
        </v-col>

        <!-- Column 2: Media Container (Visual zoom/rounded frame) -->
        <v-col lg="5" md="5" sm="12" cols="12">
          <div class="banner-image-container-modern-inner" :style="imageContainerStyle">
            <video v-if="file && file.type === 'video/mp4'" class="banner-video-modern-inner" :src="imagenIDtoSRC(obj.Imagen)"
                   preload="metadata" muted autoplay playsinline loop />
            <img v-else-if="obj.Imagen" :src="imagenIDtoSRC(obj.Imagen)" class="banner-img-modern-inner" alt="Banner" />
            <div class="image-overlay-modern-inner"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <div v-else-if="obj?.Tipo === 'dinamico'" class="banner-notin-two-dynamic bg_image">
    <div class="bg_media_dynamic"
      :style="{ backgroundImage: file && file.type != 'video/mp4' ? 'url(' + imagenIDtoSRC(obj.Imagen) + ')' : '',
                filter: imgFiltro,
                WebkitFilter: imgFiltro
              }">
    </div>

    <video v-if="file && file.type == 'video/mp4'" class="banner-video-dynamic bg_media_dynamic" :src="imagenIDtoSRC(obj.Imagen)" muted autoplay loop playsinline preload="metadata"></video>

    <div class="banner-notin-two-inner breadcrumb-area ptb--150 d-flex align-center justify-center text-center">
      <v-container>
        <v-row justify="center">
          <v-col lg="10" md="10" sm="12" cols="12">
            <div class="banner-section breadcrumb-inner-dynamic pt--50">
              <h1 class="heading-dynamic-inner" :style="tituloStyle">{{ obj.Titulo.Texto }}</h1>
              <div class="subheading-wrapper-dynamic mt--20" v-if="obj.Subtitulo && obj.Subtitulo.Texto !== ''">
                <h2 class="subheading-dynamic-inner" :style="subtituloStyle">{{ obj.Subtitulo.Texto }}</h2>
              </div>
              <div v-if="obj.ShowButton" class="slide-btn-dynamic-inner mt--40">
                <a class="rn-btn btn-dynamic-inner-primary" :href="obj.Button.Click" :style="buttonStyle">
                  {{ obj.Button.Texto }}
                </a>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>

  <div v-else class="banner-notin-two bg_image">
    <div class="bg_media"
      :style="{ backgroundImage: file && file.type != 'video/mp4' ? 'url(' + imagenIDtoSRC(obj.Imagen) + ')' : '',
                filter: imgFiltro,
                WebkitFilter: imgFiltro
              }">
    </div>

    <video v-if="file && file.type == 'video/mp4'" class="banner-video bg_media" :src="imagenIDtoSRC(obj.Imagen)" muted autoplay loop playsinline preload="metadata"></video>

    <div class="banner-notin-two-inner breadcrumb-area rn-bg-color ptb--120 parallax d-flex align-center justify-center">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="banner-section breadcrumb-inner-notin pt--100 pt_sm--40 pt_md--50">
              <h1 :style="tituloStyle">{{ obj.Titulo.Texto }}</h1>
              <h2 v-if="obj.Subtitulo && obj.Subtitulo.Texto !== ''" :style="subtituloStyle">
                {{ obj.Subtitulo.Texto }}
              </h2>
              <a v-if="obj.ShowButton" class="rn-btn" :href="obj.Button.Click" :style="buttonStyle">
                {{ obj.Button.Texto }}
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useStore } from '../../store/index';
const store = useStore();
const { NOTARIA } = storeToRefs(store);
import { useUtils } from '#imports';
const { imagenIDtoSRC, getFile } = useUtils();

const props = defineProps({
  "obj": Object,
  "type": String
});

const control = ref(props.obj);

watch(() => props.obj, (n, o) => {
  if (n && n !== o) {
    control.value = n;
  }
});

const isModerno = computed(() => control.value?.Tipo === 'moderno');

const estiloTituloShadow = computed(() => control.value?.Titulo ? '4px 2px 6px ' + control.value.Titulo.css.BackgroundColor : '');
const estiloTituloColor = computed(() => control.value?.Titulo?.css?.Color || '');
const estiloTituloFont = computed(() => control.value?.Titulo?.css?.Font || '');
const estiloTituloSize = computed(() => control.value?.Titulo?.css?.Size || '');
const estiloTituloWeight = computed(() => control.value?.Titulo?.css?.Weight || '');
const estiloTituloAlign = computed(() => control.value?.Titulo?.css?.Align || '');

const estiloSubtituloColor = computed(() => control.value?.Subtitulo?.css?.Color || '');
const estiloSubtituloShadow = computed(() => '4px 2px 6px ' + control.value?.Subtitulo?.css?.BackgroundColor || '');
const estiloSubtituloFont = computed(() => control.value?.Subtitulo?.css?.Font || '');
const estiloSubtituloWeight = computed(() => control.value?.Subtitulo?.css?.Weight || '');
const estiloSubtituloSize = computed(() => control.value?.Subtitulo?.css?.Size || '');
const estiloSubtituloAlign = computed(() => control.value?.Subtitulo?.css?.Align || '');

const estiloButtonColor = computed(() => control.value?.Button?.css?.Color || '');
const estiloButtonBackground = computed(() => control.value?.Button?.css?.BackgroundColor || '');
const estiloButtonFont = computed(() => control.value?.Button?.css?.Font || '');
const estiloButtonSize = computed(() => control.value?.Button?.css?.Size || '');
const estiloButtonWeight = computed(() => control.value?.Button?.css?.Weight || '');
const estiloButtonAlign = computed(() => control.value?.Button?.css?.Align || '');

const file = computed(() => getFile(control.value?.Imagen));
const imgFiltro = computed(() => control.value?.ImagenFiltro || "");
const img = computed(() => file.value && file.value.type !== 'video/mp4' ? "url(" + imagenIDtoSRC(control.value?.Imagen) + ")" : "");

const wrapperStyle = computed(() => ({
  backgroundColor: NOTARIA.value?.Theme?.General?.FondoCss?.BackgroundColor || '#f8fafc',
  paddingTop: '160px',
  paddingBottom: '0px',
  position: 'relative' as const,
  overflow: 'hidden' as const
}))

const imageContainerStyle = computed(() => ({
  filter: imgFiltro.value,
  WebkitFilter: imgFiltro.value
}))

const tituloStyle = computed(() => ({
  color: estiloTituloColor.value,
  textShadow: estiloTituloShadow.value,
  fontFamily: estiloTituloFont.value,
  fontSize: estiloTituloSize.value || '2.5rem',
  fontWeight: estiloTituloWeight.value,
  textAlign: estiloTituloAlign.value
}));

const subtituloStyle = computed(() => ({
  color: estiloSubtituloColor.value,
  textShadow: estiloSubtituloShadow.value,
  fontFamily: estiloSubtituloFont.value,
  fontSize: estiloSubtituloSize.value || '1.25rem',
  fontWeight: estiloSubtituloWeight.value,
  textAlign: estiloSubtituloAlign.value
}));

const buttonStyle = computed(() => ({
  color: estiloButtonColor.value,
  backgroundColor: estiloButtonBackground.value,
  fontFamily: estiloButtonFont.value,
  fontSize: estiloButtonSize.value,
  fontWeight: estiloButtonWeight.value,
  border: estiloButtonAlign.value
}));
</script>

<style scoped lang="scss">
.bg_image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bg_media {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
}

.banner-video {
  object-fit: cover;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.breadcrumb-area {
  position: relative;
  z-index: 2; 
}

.banner-notin-two .banner-notin-two-inner{
  width: 100%;
}

/* Modern Inner Banner Layout Styles */
.banner-notin-modern-inner {
  position: relative;
}

.row-gap-30 {
  row-gap: 30px;
}

.banner-glass-premium-inner {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 24px;
  padding: 45px 40px;
  box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.03);
  background: #ffffff;
  transition: all 0.4s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  animation: fadeInLeftInner 1s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover {
    box-shadow: 0 15px 45px 0 rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.08);
  }
}

.heading-modern-inner {
  letter-spacing: -1px;
  line-height: 1.25;
}

.subheading-modern-inner {
  line-height: 1.4;
  opacity: 0.9;
}

.btn-modern-primary-inner {
  text-transform: none !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 12px;
  padding: 14px 32px;
  display: inline-block;
  line-height: 1;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: 0.5s;
  }

  &:hover {
    transform: translateY(-3px) scale(1.01);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
    
    &::before {
      left: 100%;
    }
  }
}

.banner-image-container-modern-inner {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
  height: 100%;
  min-height: 320px;
  aspect-ratio: 4 / 3;
  animation: fadeInRightInner 1s cubic-bezier(0.165, 0.84, 0.44, 1);

  .banner-img-modern-inner, .banner-video-modern-inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &:hover {
    .banner-img-modern-inner, .banner-video-modern-inner {
      transform: scale(1.05);
    }
  }
}

.image-overlay-modern-inner {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
}

@keyframes fadeInLeftInner {
  from { opacity: 0; transform: translateX(-40px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInRightInner {
  from { opacity: 0; transform: translateX(40px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Clásico Dinámico Inner Banner Layout Styles */
.banner-notin-two-dynamic {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.bg_media_dynamic {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  transition: transform 10s ease-out;
}

.banner-notin-two-dynamic:hover .bg_media_dynamic {
  transform: scale(1.08);
}

.heading-dynamic-inner {
  line-height: 1.2;
  letter-spacing: -1px;
  animation: fadeInUpInner 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}

.subheading-dynamic-inner {
  animation: fadeInUpInner 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s forwards;
  opacity: 0;
}

.btn-dynamic-inner-primary {
  text-transform: none !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 30px;
  padding: 14px 40px;
  display: inline-block;
  line-height: 1;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: fadeInUpInner 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) 0.4s forwards;
  opacity: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
  }
}

@keyframes fadeInUpInner {
  from {
    opacity: 0;
    transform: translateY(25px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 960px) {
  .banner-notin-modern-inner {
    padding-top: 120px;
    padding-bottom: 0px;
  }
  .banner-glass-premium-inner {
    text-align: center !important;
    padding: 35px 25px;
  }
  .banner-image-container-modern-inner {
    min-height: 250px;
  }
}
</style>